import { MOCK_TEMPLATES } from '../../mocks/messages';

const MessagesTemplates = () => (
  <div className="space-y-4">
    <div>
      <h2 className="font-display text-2xl font-light text-ink-900">Templates</h2>
      <p className="mt-1 text-sm text-ink-700/80">
        Saved WhatsApp copy your team can send once the account is connected.
      </p>
    </div>
    <ul className="space-y-3">
      {MOCK_TEMPLATES.map((tpl) => (
        <li key={tpl.id} className="bg-sand-50 px-5 py-4 ring-1 ring-ink-900/10">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="font-medium text-ink-900">{tpl.name}</p>
            <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/55">
              {tpl.channel}
            </span>
          </div>
          <p className="mt-2 text-sm leading-relaxed text-ink-700/85">{tpl.body}</p>
        </li>
      ))}
    </ul>
  </div>
);

export default MessagesTemplates;
